import { jsx as _jsx } from "react/jsx-runtime";
import { NodeStatusModalForm } from '../EntityModalForms/NodeStatusModalForm';
function CreateNodeStatusModal({ isOpen, onClose, onCreate, isLoading }) {
    return (_jsx(NodeStatusModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onCreate, isLoading: isLoading, mode: "create", nodeStatus: null, title: "Create Node Status", submitIdleLabel: "Create", submitBusyLabel: "Creating...", bindingSelectId: "bindings" }));
}
export default CreateNodeStatusModal;
